import React, { useEffect, useState } from 'react';

const Modal = ({ isOpen, children }) => {
    const [fadeType, setFadeType] = useState();

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflowY = 'hidden';
            setFadeType('in');
        } else {
            document.body.style.overflowY = 'auto';
            setFadeType('out');
        }

        return function closeModal() {};
    }, [isOpen]);

    if (isOpen) {
        return (
            <div className={`modal-container fade-${fadeType}`}>
                <div className='modal'>
                    <div className='modal-body'>{children}</div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default Modal;
